<template>
    <div class="c-try-it-yourself">
        <div
            v-if="!dontShowContent && !hiddenTitle"
            class="c-try-it-yourself__title"
        >
            <h3>
                {{ content.title }}
            </h3>
        </div>
        <div class="c-try-it-yourself__content">
            <div
                v-if="iframe && iframeField && content.custom[iframeField]"
                class="c-try-it-yourself__content__iframe"
                v-html="content.custom[iframeField]"
            />
            <div
                v-else-if="!showVideo"
                class="c-try-it-yourself__content__cover"
                :style="{ backgroundImage: `url(${content.image.versions.main1 ? content.image.versions.main1 : content.image.link})` }"
            >
                <div class="c-try-it-yourself__content__cover__text-box">
                    <p
                        v-if="!dontShowContent"
                        class="description pa-1"
                        v-html="content.synopsis"
                    />
                    <y-button
                        class="text-box-btn"
                        color="primary"
                        :icon-append="dontShowContent ? 'fa-caret-right' : ''"
                        @click.prevent="showVideo = true"
                    >
                        <span v-if="!dontShowContent">{{ $t('home.watch_now') }}</span>
                    </y-button>
                </div>
            </div>
            <div
                v-else
                class="c-try-it-yourself__content__video"
            >
                <y-player :src="content.albums[0].link" />
            </div>
        </div>
    </div>
</template>

<script>
    import { YPlayer } from '@groot-components/all';

    export default {
        name      : 'TryItYourself',
        components: { YPlayer },
        props     : {
            content        : Object,
            dontShowContent: Boolean,
            hiddenTitle    : {
                type   : Boolean,
                default: false,
            },
            iframe     : Boolean,
            iframeField: String,
        },
        /**
         * @inheritDoc
         */
        data() {
            return {
                showVideo: false,
            };
        },
    };
</script>

<style lang="scss" src="./index.scss"></style>
